import _ from 'lodash/fp'

import colors from '@fe/ui/colors'

const icons = {
  glfrLogo: require('./icons/GLFR-Green-Landscape-64.png'),
  mapMarkerGreen: require('./icons/mapMarkerGreen.png'),
  mapMarkerGreenPale: require('./icons/mapMarkerGreenPale.png'),
  golf: require('./icons/white_flag.png')
}

const images = {
  icons
}

export default images

const checkImage = (path) =>
  new Promise(resolve => {
    const img = new window.Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.src = path
  })

// Creates 'a house' with a club logo on it
export const generateHomeClubMarker = async (logo, width, height, color) => {
  const cv = document.createElement('canvas')
  const ct = cv.getContext('2d')

  const margin = 7
  const logoWidth = width - (margin * 2)
  const logoHeight = height - (margin * 2)

  cv.width = width
  cv.height = height

  ct.beginPath()
  ct.lineTo(0, 0.4 * height)
  ct.strokeStyle = colors.white
  ct.fillStyle = color
  ct.lineTo(0.1 * width, 0.4 * height)
  ct.lineTo(0.1 * width, height)
  ct.lineTo(0.9 * width, height)
  ct.lineTo(0.9 * width, 0.4 * height)
  ct.lineTo(width, 0.4 * height)
  ct.lineTo(0.5 * width, 0)
  ct.lineTo(0, 0.4 * height)
  ct.lineWidth = 2
  ct.closePath()
  ct.stroke()
  ct.fill()
  if (logo) {
    const logoImage = await checkImage(logo)
    ct.drawImage(logoImage, margin, margin + margin, logoHeight, logoWidth)
  }

  const url = cv.toDataURL('image/png')

  return url
}

// Creates a circle with the club logo inside a margin
export const generateCustomerMarker = async (logo, width, height, color, margin = 8) => {
  const cv = document.createElement('canvas')
  const ct = cv.getContext('2d')

  const logoWidth = width - (margin * 2)
  const logoHeight = height - (margin * 2)

  cv.width = width
  cv.height = height

  ct.strokeStyle = colors.white
  ct.fillStyle = color
  ct.lineWidth = 2
  ct.beginPath()
  ct.arc(width / 2, height / 2, height / 2 - ct.lineWidth * 2, 0, 2 * Math.PI)
  ct.closePath()
  ct.stroke()
  ct.fill()

  ct.fillStyle = colors.white
  ct.beginPath()
  ct.arc(width * 0.5, height * 0.5, (logoWidth + logoHeight) * 0.25, 0, 2 * Math.PI)
  ct.closePath()
  ct.stroke()
  ct.fill()

  if (logo) {
    const logoImage = await checkImage(logo)
    ct.drawImage(logoImage, margin, margin, logoHeight, logoWidth)
  }

  const url = cv.toDataURL('image/png')

  return url
}

// Creates a circle with golf icon inside
export const generateBasicMarker = async (width, height, color, margin = 6) => {
  const logo = icons.golf
  const cv = document.createElement('canvas')
  const ct = cv.getContext('2d')

  const logoWidth = width - (margin * 2)
  const logoHeight = height - (margin * 2)

  cv.width = width
  cv.height = height

  ct.strokeStyle = colors.white
  ct.fillStyle = color
  ct.lineWidth = 2
  ct.beginPath()
  ct.arc(width / 2, height / 2, height / 2 - ct.lineWidth * 2, 0, 2 * Math.PI)
  ct.closePath()
  ct.stroke()
  ct.fill()

  if (logo) {
    const logoImage = await checkImage(logo)
    ct.drawImage(logoImage, margin, margin, logoHeight, logoWidth)
  }

  const url = cv.toDataURL('image/png')

  return url
}

// Is made to put an image on a google maps like icon
export const markerDecorator = async (markerPath, logo, customer, width, height, callback) => {
  const c = document.createElement('canvas')
  c.height = height
  c.width = width
  const ctx = c.getContext('2d')

  const markerImage = await checkImage(_.get(markerPath, images))
  ctx.drawImage(markerImage, 0, 0)

  if (customer && logo) {
    const logoImage = await checkImage(logo)
    ctx.fillStyle = 'white'
    ctx.beginPath()
    ctx.arc(12.5, 13, 10, 0, Math.PI * 2)
    ctx.fill()
    ctx.drawImage(logoImage, 2.5, 3, 20, 20)
  }
  return c.toDataURL('image/png')
}
